(function ($) {
  const initializeBlock = function ($block) {
    function matchHeightFire() {
      $(".iconBoxes .iconBoxes__item .iconBoxes__item__icon").matchHeight({
        property: "min-height",
      });
      $(
        ".iconBoxes .iconBoxes__item .iconBoxes__item__info__title"
      ).matchHeight({
        property: "min-height",
      });
    }
    matchHeightFire();

    $(window).bind("resize orientationchange", function () {
      matchHeightFire();
    });

    setTimeout(function () {
      matchHeightFire();
    }, 1000);
  };

  $(document).ready(function () {
    $(".block--icon-boxes").each(function () {
      initializeBlock($(this));
    });
  });

  if (window.acf) {
    window.acf.addAction(
      "render_block_preview/type=icon-boxes",
      initializeBlock
    );
  }
})(jQuery);
